<template>
    <div class='magazine-filter'>
        <div class="row">
            <div class="col-12">
                <el-card class="box-card" v-if="loaded === true">
                    <div class="row pl-10 pr-10">
                        <div class="col-4 center-align-vert">
                            <img src="@/assets/logo.png" height="50px">
                        </div>
                        <div class="col-8">
                            <div class="filter-container">
                                <div class="filter-component">
                                    <h4 class="filter-label text-left">Stores</h4>
                                    <el-select v-if="userLoggedIn" v-model="$store.state.magazine.stores" placeholder="Select" class="text-left store-select" @visible-change="selectChange" multiple collapse-tags :clearable=false>
                                        <el-option
                                            v-for="s in $store.state.general.stores"
                                            :label=s.store_name
                                            :value=s.store_id
                                            :key=s.store_id>
                                        </el-option>
                                    </el-select>
                                    <el-select v-if="!userLoggedIn" v-model="$store.state.magazine.stores" placeholder="Select" class="text-left store-select" @visible-change="selectChange" multiple collapse-tags :clearable=false>
                                        <el-option
                                            v-for="s in $store.state.magazine.stores"
                                            :label=s
                                            :value=s
                                            :key=s
                                            :disabled=true>
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="filter-component">
                                    <h4 class="filter-label text-left">Week</h4>
                                    <el-select v-model="$store.state.magazine.week" placeholder="Select" class="text-left" @visible-change="selectChange">
                                        <el-option
                                            v-for="w in 52"
                                            :label=w
                                            :value=w
                                            :key=w>
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="filter-component ml-10">
                                    <h4 class="filter-label text-left">Year</h4>
                                    <el-select v-model="$store.state.magazine.year" placeholder="Year" class="text-left" @visible-change="selectChange">
                                        <el-option
                                            label="2020"
                                            value=2020>
                                        </el-option>
                                        <el-option
                                            label="2019"
                                            value=2019>
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
                <el-card class="box-card" v-else style="height: 80px;">
                    <div class="card-body no-padding">
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loaded: false
        }
    },
    components: {
    },
    computed: {
        userLoggedIn () {
            return this.$auth.isAccessTokenValid()
        }
    },
    methods: {
        getQueryParameters () {
            for (let param in this.$route.query) {
                if (param === 'amount' || param === 'year' || param === 'week') {
                    this.$store.commit('magazine/UPDATE_VALUE', { 'variable': param, 'value': parseInt(this.$route.query[param]) })
                    this.$emit('filterChanged')
                } else if (param === 'stores') {
                    let stores = this.$route.query.stores.split(',')
                    for (let idx in stores) {
                        stores[idx] = parseInt(stores[idx])
                    }
                    this.$store.commit('magazine/UPDATE_VALUE', { 'variable': param, 'value': stores })
                    this.$emit('filterChanged')
                }
            }
        },
        selectChange (event) {
            if (event === false) {
                this.$emit('filterChanged')
            }
        }

    },
    created () {
        if (this.$auth.isAccessTokenValid()) {
            let promiseList = [this.$store.dispatch('general/getStores'), this.$store.dispatch('general/getStoreInterests')]
            Promise.all(promiseList).then(response => {
                this.$emit('filterLoaded')
                this.getQueryParameters()
                this.loaded = true
            })
        } else {
            this.$emit('filterLoaded')
            this.getQueryParameters()
            this.loaded = true
        }
    }
}
</script>

<style lang="scss">
.magazine-filter {
    .el-select {
        width: 100px !important;
    }
    .store-select {
        width: 200px !important;
    }
    .filter-container {
        float: right;
    }
    .filter-component {
        display: inline-block;
    }
    .filter-label {
        display: block;
    }
    .el-input__inner {
        border: none;
    }
    .el-select__caret {
        display: none;
    }
    .col-12 {
        padding-right: 15px;
        padding-left: 15px;
    }
    .el-tag__close {
        display: none;
    }
    .el-input__inner {
        padding: 0px 0px 0px 5px;
    }
    .el-tag {
        margin: 0px;
    }
}
</style>
